import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@blueprintjs/core";
import style from "../../../style.module.css";
import Callout from "../../../../core/Callout";
import Title from "../Title";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";

// routes
import { Link } from "react-router-dom";
import Svg from "../../../../component/common/Svg";

export const VerifyEmail = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);


  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <div className='d-flex flex-column site-main-wrapper login-page'>
      <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
        <div className="container">
          <div className="form-outer-wrapper">
            <div className="logo-wrap text-center">
              <Link to="/#0t" className='home-logo'>
                <Svg name="logo" />
              </Link>
            </div>
            <div className="form-wrapper">
              <div className="form-heading mb-0">
                <h3>Verify Your email address</h3>
                <p className="mb-4 ms-0"><b>Here is your  6 digit  confirmation code</b></p>
              </div>
              <Card style={{ textAlign: "center" }} className={"formotp"}
                type='def'
                view='smooth'
                color='default'
                interactive='false'
              >
                <b>623-324</b>
              </ Card >

              <p className="mb-3 ms-0">
                <b>If you didn't request this email, you can safely ignore it.</b>
              </p>

              <Callout className={"formcallout"}
                type='def'
                view='smooth'
                color='#728095'
                title={null}
                icon={< Icon icon='info-sign' iconSize={16} />}
              >
                <b> To ensure the security of your data, please do not share this email. Learn more about how we're keeping your documents and data safe.</b>
              </ Callout >

            </div>
          </div>
        </div>
      </div>


    </div >
  );
};

export default VerifyEmail;
